import { useEffect, useState } from 'react';
import axios from '../config/api';

export interface FunnelCounts {
  menu_views: number;
  cart_adds: number;
  checkout_started: number;
  loading: boolean;
}

export function useFunnelCounts(
  selectedCafe: string,
  start: Date,
  end: Date,
  enabled = true
): FunnelCounts {
  const [counts, setCounts] = useState<FunnelCounts>({
    menu_views: 0,
    cart_adds: 0,
    checkout_started: 0,
    loading: true,
  });

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const params = new URLSearchParams({
      from: start.toISOString(),
      to: end.toISOString(),
    });
    if (selectedCafe) params.set('cafe_id', selectedCafe);

    setCounts((prev) => ({ ...prev, loading: true }));
    axios
      .get<{
        menu_views: number;
        cart_adds: number;
        checkout_started: number;
      }>(`/api/analytics/funnel?${params.toString()}`)
      .then((res) => {
        if (cancelled) return;
        setCounts({
          menu_views: Number(res.data.menu_views) || 0,
          cart_adds: Number(res.data.cart_adds) || 0,
          checkout_started: Number(res.data.checkout_started) || 0,
          loading: false,
        });
      })
      .catch(() => {
        if (!cancelled) {
          setCounts({
            menu_views: 0,
            cart_adds: 0,
            checkout_started: 0,
            loading: false,
          });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [selectedCafe, start.getTime(), end.getTime(), enabled]);

  return counts;
}
